<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap>
                <v-flex xs9>
                  <div>
                    <h2 v-text="merchant.merchant_name" class="font-weight-light"></h2>
                  </div>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-card-title>

            <!-- <div class="abs">
                    <v-flex xs12>
                        <v-btn
                          class="elevation-5"
                          color= "success"
                          slot="activator"
                          v-if="change==true"
                          @click="save_btn"
                          large dark icon>
                          <v-icon>check</v-icon>
                        </v-btn>
                    </v-flex>
                    
                    <v-flex xs12>
                      <v-tooltip top>
                        <v-btn
                          class="elevation-5"
                          :class="{ 'primary': !change, 'secondary': change }"
                          slot="activator"
                          :disabled="change"
                          @click="edit_btn"
                          large dark icon>
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <span>Edit Merchant Details</span>
                      </v-tooltip>
                    </v-flex>

                    <v-dialog v-model="delete_modal" persistent max-width="290">
                      <v-btn class="elevation-5" slot="activator" color="error" large dark icon>
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <v-card>
                        <v-card-title class="headline">Confirm Delete</v-card-title>
                        <v-card-text>
                          Do you wish to delete {{ merchant.name }}?
                          <p class="small-font error--text mt-2 mb-0">**This cannot be reversed</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" flat @click.native="delete_modal = false">Cancel</v-btn>
                          <v-btn color="error" flat @click.native="delete_modal = false">Delete</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
            </div>-->
            <v-card-text class="pt-0 mt-4">
              <v-expansion-panel popout v-model="panel">
                <v-expansion-panel-content>
                  <div slot="header">
                    <h3>Merchant Details  :  {{ updatedMerchant.name }}</h3>
                  </div>
                  <v-form>
                    <v-card>
                      <v-card-text class="activegrey">
                        <v-layout row wrap>
                          <v-flex xs12 sm6 px-3>
                            <div class="full-width">
                              <label>Merchant Name</label>
                              <v-flex>
                                <v-text-field
                                  v-model="updatedMerchant.name"
                                  :disabled="!merchantEdit"
                                  solo
                                ></v-text-field>
                              </v-flex>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm6 px-3>
                            <div class="full-width">
                              <label>Merchant Phone</label>
                              <v-flex>
                                <v-text-field
                                  v-model="updatedMerchant.phone"
                                  :disabled="!merchantEdit"
                                  solo
                                ></v-text-field>
                              </v-flex>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm6 px-3>
                            <div class="full-width">
                              <label>Business Type</label>
                              <v-flex>
                                <v-autocomplete
                                  v-model="updatedMerchant.business_type"
                                  :disabled="!merchantEdit"
                                  solo
                                  label="Business Type"
                                  :items="businessTypes"
                                  item-text="rep"
                                  item-value="id"
                                ></v-autocomplete>
                              </v-flex>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm6 px-3>
                            <div class="full-width">
                              <label>Category</label>
                              <v-flex>
                                <v-select
                                  v-model="updatedMerchant.category"
                                  :disabled="!merchantEdit"
                                  solo
                                  :items="categories"
                                  item-text="name"
                                  item-value="value"
                                ></v-select>
                              </v-flex>
                            </div>
                          </v-flex>

                          <v-flex xs12 justify-end px-3 pb-3>
                            <v-btn
                              v-if="!merchantEdit"
                              color="secondary"
                              @click="merchantEdit=true"
                            >EDIT</v-btn>
                            <div v-else>
                              <v-btn flat color="error" @click="merchantEdit=false">CANCEL</v-btn>
                              <v-btn color="success" @click="updateMerchant">SAVE</v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-form>
                </v-expansion-panel-content>

                <v-expansion-panel-content v-for="(location,index) in locations" :key="index">
                  <div slot="header">
                    <h3 v-text="location.address"></h3>
                  </div>
                  <v-card>
                    <v-card-text class="activegrey">
                      <v-layout row wrap>
                        <v-form>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Merchant Address</label>
                                <v-flex>
                                  <v-textarea
                                    v-model="locations[index].address"
                                    :disabled="!locationEdits[index]"
                                    solo
                                  ></v-textarea>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Assigned Marshal</label>
                                <v-flex>
                                  <v-autocomplete
                                    solo
                                    v-model="locations[index].marshal"
                                    :items="marshals"
                                    item-text="full_name"
                                    item-value="id"
                                    :disabled="!locationEdits[index]"
                                  ></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Route</label>
                                <v-flex>
                                  <v-text-field
                                    v-model="locations[index].route"
                                    :disabled="!locationEdits[index]"
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Area</label>
                                <v-flex>
                                  <v-text-field
                                    v-model="locations[index].area"
                                    :disabled="!locationEdits[index]"
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Attendant Name</label>
                                <v-flex>
                                  <v-text-field
                                    v-model="locations[index].attendant_name"
                                    :disabled="!locationEdits[index]"
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Attendant Phone</label>
                                <v-flex>
                                  <v-text-field
                                    v-model="locations[index].attendant_phone"
                                    :disabled="!locationEdits[index]"
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Visitation</label>
                                <v-flex>
                                  <v-select
                                    v-model="locations[index].visitation"
                                    :disabled="!locationEdits[index]"
                                    solo
                                    :items="visitations"
                                    item-text="name"
                                    item-value="value"
                                  ></v-select>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Visits this month</label>
                                <v-flex>
                                  <v-text-field
                                    v-model="location.visits_this_month"
                                    :disabled="true"
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>

                            <v-flex xs12 justify-end px-3 pb-3>
                              <v-btn color="secondary" @click="scheduleVisit(index)">SCHEDULE VISIT</v-btn>
                              <v-btn
                                v-if="!locationEdits[index]"
                                color="secondary"
                                @click="editLocation(index, true)"
                              >EDIT</v-btn>
                              <v-btn flat color="error" 
                                v-if="locationEdits[index]"
                                @click="editLocation(index, false)"
                              >CANCEL</v-btn>
                              <v-btn
                                v-if="locationEdits[index]"
                                color="success"
                                @click="updateLocation(index)"
                              >SAVE</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-form>

                        <v-expansion-panel>
                          <v-expansion-panel-content
                            v-for="(tid,tIndex) in location.terminals"
                            :key="tIndex"
                            class="primary mb-1 br-2"
                          >
                            <div slot="header" class="white--text">Terminal {{ tIndex+1 }} - {{ tid.terminal_uuid }}</div>
                            <v-form>
                              <v-card dark color="#666">
                                <v-card-text class="activegrey lighten">
                                  <v-layout row wrap>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Terminal ID</label>
                                        <v-flex>
                                          <v-text-field
                                            v-model="location.terminals[tIndex].terminal_uuid"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                          ></v-text-field>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Serial No</label>
                                        <v-flex>
                                          <v-text-field
                                            v-model="tid.serial_no"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                          ></v-text-field>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Merchant ID</label>
                                        <v-flex>
                                          <v-text-field
                                            v-model="tid.merchant_uuid"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                          ></v-text-field>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Terminal Type</label>
                                        <v-flex>
                                          <v-autocomplete
                                            v-model="tid.terminal_type"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                            :items="terminalTypes"
                                            item-text="rep"
                                            item-value="id"
                                          ></v-autocomplete>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Terminal App</label>
                                        <v-flex>
                                          <v-autocomplete
                                            v-model="tid.terminal_app"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                            :items="terminalApps"
                                            item-text="rep"
                                            item-value="id"
                                          ></v-autocomplete>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-3>
                                      <div class="full-width">
                                        <label>Bank</label>
                                        <v-flex>
                                          <v-autocomplete
                                            v-model="tid.bank"
                                            :disabled="!terminalEdits[tIndex]"
                                            solo
                                            :items="banks"
                                            item-text="name"
                                            item-value="id"
                                          ></v-autocomplete>
                                        </v-flex>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 justify-end px-3 pb-3>
                                      <v-dialog
                                        v-model="delete_terminal"
                                        persistent
                                        max-width="290"
                                      >
                                        <v-btn
                                          v-if="!terminalEdits[tIndex]"
                                          color="secondary"
                                          slot="activator"
                                        >DELETE</v-btn>
                                        <v-card>
                                          <v-card-title class="headline">Confirm Delete</v-card-title>
                                          <v-card-text>
                                            <h3 v-text="merchant.name"></h3>
                                            Do you wish to delete this terminal with TERMINAL ID: {{ tid.terminal_uuid }}?
                                            <p
                                              class="small-font error--text mt-2 mb-0"
                                            >**This cannot be reversed</p>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              color="secondary"
                                              flat
                                              @click.native="delete_terminal = false"
                                            >Cancel</v-btn>
                                            <v-btn
                                              color="error"
                                              flat
                                              @click.native="deleteTerminal(index, tIndex)"
                                            >Delete</v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                      <v-btn
                                        v-if="!terminalEdits[tIndex]"
                                        color="primary"
                                        @click="editTerminal(tIndex, true)"
                                      >EDIT</v-btn>
                                      <v-btn v-if="terminalEdits[tIndex]"
                                        flat color="error"
                                        @click="editTerminal(tIndex, false)"
                                      >CANCEL</v-btn>
                                      <v-btn
                                        v-if="terminalEdits[tIndex]"
                                        color="success"
                                        @click="updateTerminal(index, tIndex)"
                                      >SAVE</v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-form>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-flex justify-end px-3 mt-3>
                          <v-dialog v-model="delete_location" persistent max-width="290">
                            <v-btn
                              v-if="!locationEdits[index]"
                              color="error"
                              slot="activator"
                            >DELETE LOCATION</v-btn>
                            <v-card>
                              <v-card-title class="headline">Confirm Delete</v-card-title>
                              <v-card-text>
                                <h3 v-text="merchant.name"></h3>
                                Do you wish to delete {{ location.address }}?
                                <p
                                  class="small-font error--text mt-2 mb-0"
                                >**This cannot be reversed</p>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="secondary"
                                  flat
                                  @click.native="delete_location = false"
                                >Cancel</v-btn>
                                <v-btn
                                  color="error"
                                  flat
                                  @click.native="deleteLocation(index)"
                                >Delete</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>

          <v-flex justify-end mt-4>
            <v-dialog v-model="delete_merchant" persistent max-width="290">
              <v-btn v-if="!merchantEdit" color="error" slot="activator">DELETE MERCHANT</v-btn>
              <v-card>
                <v-card-title class="headline">Confirm Delete</v-card-title>
                <v-card-text>Do you wish to delete
                  <span class="font-weight-bold" v-text="merchant.name"></span>
                  with all {{ merchant.locations.length }} location(s)?
                  <p class="small-font error--text mt-2 mb-0">**This cannot be reversed</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" flat @click.native="delete_merchant = false">Cancel</v-btn>
                  <v-btn color="error" flat @click.native="deleteMerchant">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "../../../layouts/admin"
import utils from "@/common/utils"
import { mapGetters, mapState } from "vuex"
import { SUBMIT_REPORT } from "@/store/actions/marshal"
import {
  FETCH_MERCHANT,
  UPDATE_MERCHANT,
  UPDATE_MERCHANT_LOCATION,
  UPDATE_TERMINAL,
  DELETE_MERCHANT,
  DELETE_MERCHANT_LOCATION,
  DELETE_TERMINAL
} from "@/store/actions/merchant"
import { SCHEDULE_VISIT } from "../../../store/actions/ptspAdmin"

export default {
  name: "AdminMarshals",
  data() {
    return {
      page_title: "Merchant",
      getDate: new Date(),
      fab: false,
      edit_modal: false,
      delete_modal: false,
      panel: [],
      updatedMerchant: {},
      locations: [],
      change: false,
      delete_merchant: false,
      delete_terminal: false,
      delete_location: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      merchantEdit: false,
      locationEdits: {},
      terminalEdits: {}
    }
  },
  // watch: {
  //   locations: 'changeLocation'
  // },
  computed: {
    ...mapState({
      merchant: state => state.merchant.merchant,
      banks: state => state.common.banks,
      businessTypes: state => state.common.businessTypes,
      marshals: state => state.admin.marshals,
      terminalTypes: state => state.common.terminalTypes,
      terminalApps: state => state.common.terminalApps
    }),
    // merchant() {
    //   return this.$store.getters.getMerchantById(this.$route.params.id)
    // },

    categories: function() {
      return utils.CATEGORY_CHOICES
    },
    visitations: function() {
      return utils.VISITATION_CHOICES
    },
    itemTypes: function() {
      return utils.ITEM_CHOICES
    },
    dataProviders: function() {
      return utils.DATA_PROVIDERS
    }
  },
  methods: {
    edit_btn() {
      this.change = true
      this.panel = [...Array(this.terminals).keys()].map(_ => true)
    },
    save_btn() {
      this.change = false
      this.panel = []
    },
    toroute(route) {
      this.$router.push(route)
    },
    show_snackbar(message, color, url) {
      this.snackbar.text = message
      this.snackbar.color = color + " darken-1"
      this.snackbar.url = url
      this.snackbar.show = true
    },
    editLocation(index, status) {
      this.locationEdits[index] = status
      this.$forceUpdate()
    },
    editTerminal(tIndex, status) {
      this.terminalEdits[tIndex] = status
      this.$forceUpdate()
    },
    updateMerchant() {
      this.$store.dispatch(UPDATE_MERCHANT, this.updatedMerchant).then(() => {
        // Show form submitted toast
        this.merchantEdit = false
      })
    },
    deleteMerchant() {
      this.$store
        .dispatch(DELETE_MERCHANT, this.updatedMerchant.id)
        .then(() => {
          // Show form submitted toast
          this.merchantEdit = false
          this.delete_merchant = false
        })
    },
    changeStoreMerchant(e) {
      console.log(e)
      // this.$store.commit('CHANGE_MERCHANT', e)
    },
    scheduleVisit(index) {
      this.$store
        .dispatch(SCHEDULE_VISIT, this.locations[index])
        .then(() => {
          // Show form submitted toast
          this.editLocation(index, false)
          utils.showSnackbar({
            message: `Visit scheduled to merchant 
            ${this.locations[index].merchant_name} ${
              this.locations[index].area
            }`,
            url:"",
            color:"primary darken-1",
            timeout:10000
          })
        })
    },
    updateLocation(index) {
      this.$store
        .dispatch(
          UPDATE_MERCHANT_LOCATION,
          this.locations[index]
        )
        .then(() => {
          // Show form submitted toast
          this.editLocation(index, false)
        })
    },
    deleteLocation(index) {
      const locationId = this.locations[index].id
      this.$store.dispatch(DELETE_MERCHANT_LOCATION, locationId).then(() => {
        // Show form submitted toast
        this.editLocation(index, false)
        this.delete_location = false
      })
    },

    updateTerminal(lIndex, tIndex) {
      const terminal = this.locations[lIndex].terminals[tIndex]
      this.$store.dispatch(UPDATE_TERMINAL, terminal).then(() => {
        // Show form submitted toast
        this.editTerminal(tIndex)
      })
    },
    deleteTerminal(lIndex, tIndex) {
      const terminalId = this.locations[lIndex].terminals[
        tIndex
      ].id
      this.$store.dispatch(DELETE_TERMINAL, terminalId).then(() => {
        // Show form submitted toast
        this.editTerminal(tIndex)
        this.delete_terminal = false
      })
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_MERCHANT, this.$route.params.id)
    .then(() => {
      this.updatedMerchant = JSON.parse(JSON.stringify(this.merchant))
      let loc = (this.$route.params.location_id) ?
        this.updatedMerchant.locations.filter(
          location => location.id == this.$route.params.location_id
        ) : this.updatedMerchant.locations
      this.locations = [...loc]
    })
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  }
}
</script>

<style scoped>
.full-width {
  width: 100%
}

.box {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.abs {
  position: fixed;
  z-index: 10;
  right: 50px;
  bottom: 5vh;
}

.lightgrey {
  background: #ccc
}

.activegrey {
  background: rgba(242, 242, 242, 0.3)
}

.activegrey.lighten {
  background: rgba(159, 146, 126, 0.04)
}

.small-font {
  font-size: 12px
}

.width-70 {
  width: 80%
}

.br-2 {
  border-radius: 3px
}
</style>

